import { useTranslation } from 'react-i18next'

import { OpportunityForm as F } from '@percent/domain/volunteering'
import { Loader } from '@percent/lemonade'

import type { UseCreateOpportunityFormResult } from '../create/useCreateOpportunityForm'
import { UseEditOpportunityFormResult } from '../edit/useEditOpportunityForm'

type SkillsAndActivitiesSectionProps = Pick<
  F.SkillsAndActivitiesSectionProps,
  'onSkillsChange' | 'onActivitiesChange'
> &
  Pick<
    UseCreateOpportunityFormResult | UseEditOpportunityFormResult,
    'values' | 'errors' | 'touched' | 'setFieldTouched' | 'partnerConfig'
  >

export function SkillsAndActivitiesSection({
  values,
  errors,
  touched,
  onSkillsChange,
  onActivitiesChange,
  setFieldTouched,
  partnerConfig
}: Readonly<SkillsAndActivitiesSectionProps>) {
  const { t } = useTranslation()

  if (!partnerConfig.enabled) {
    return null
  }

  if (partnerConfig.isLoading) {
    return <Loader />
  }

  return (
    <F.SkillsAndActivitiesSection
      skillsValue={values.skills}
      onSkillsChange={onSkillsChange}
      activitiesValue={values.activities}
      onActivitiesChange={onActivitiesChange}
      activitiesTouched={touched.activities}
      setActivitiesTouched={() => setFieldTouched('activities')}
      activitiesError={Array.isArray(errors.activities) ? errors.activities.join(', ') : errors.activities}
      skillsData={partnerConfig.skills}
      areSkillsLoading={false}
      activitiesData={partnerConfig.activities}
      areActivitiesLoading={false}
      sectionTitle={t('volunteering.opportunity.form.common.skillsAndActivitiesSection.title')}
      aiGenerationLabelA=""
      aiGenerationLabelB=""
      skillsLabel={t('volunteering.opportunity.form.common.skillsAndActivitiesSection.skillsField.label')}
      skillsPlaceholder={t('volunteering.opportunity.form.common.skillsAndActivitiesSection.skillsField.placeholder')}
      activitiesLabel={t('volunteering.opportunity.form.common.skillsAndActivitiesSection.activitiesField.label')}
      activitiesPlaceholder={t(
        'volunteering.opportunity.form.common.skillsAndActivitiesSection.activitiesField.placeholder'
      )}
    />
  )
}
